// Temporary workaround. Resolve ASAP. Do not add more ignores like this.
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import { api } from '@marketplace-web/core-api/core-api-client-util'

import { CountriesResp } from '../types/countries-resp'

export const getCountries = (locale?: string) =>
  api.get<CountriesResp>('/countries', {
    params: locale ? { locale } : {},
  })
